import { render, staticRenderFns } from "./BoilerplateAndComments.vue?vue&type=template&id=63e53532&scoped=true&"
import script from "./BoilerplateAndComments.vue?vue&type=script&lang=ts&"
export * from "./BoilerplateAndComments.vue?vue&type=script&lang=ts&"
import style0 from "./BoilerplateAndComments.vue?vue&type=style&index=0&id=63e53532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e53532",
  null
  
)

export default component.exports